var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0.5L6.68461 1.19384L8.05598 1.12999L8.78246 2.29487L10.0264 2.87564L10.1283 4.24471L10.9599 5.33705L10.4139 6.59666L10.6426 7.95033L9.57377 8.81192L9.14717 10.1168L7.80038 10.383L6.81624 11.3402L5.5 10.95L4.18376 11.3402L3.19962 10.383L1.85283 10.1168L1.42623 8.81192L0.35741 7.95033L0.586091 6.59666L0.0401011 5.33705L0.87167 4.24471L0.973589 2.87564L2.21754 2.29487L2.94402 1.12999L4.31539 1.19384L5.5 0.5Z",
    fill: "#4569FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64102 3.97897C7.90599 3.74041 8.33624 3.74041 8.60122 3.97897C8.8662 4.21754 8.8662 4.6049 8.60122 4.84347L5.07248 8.0205C4.94507 8.13521 4.77241 8.20005 4.59238 8.20005C4.41141 8.20005 4.23969 8.13521 4.11228 8.0205L2.39869 6.4777C2.13371 6.2383 2.13371 5.85261 2.39869 5.61321C2.66459 5.37381 3.09391 5.37381 3.35889 5.61321L4.59238 6.72292L7.64102 3.97897Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.ca597904.svg";
export { ForwardRef as ReactComponent };